<template>
  <div class="role">
    <div class="page">
      <div class="page-header white-bg">
        <size-change @sizeChange="sizeChange"></size-change>
        <div class="header-right">
          <vs-input
            class="search-words"
            v-model="words"
            placeholder="ID/产品名称/产品编码"
          ></vs-input>
          <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
          <vs-button type="border" color="primary" @click="addHandle">添加</vs-button>
        </div>
      </div>
      <div class="page-content white-bg">
        <vs-table :data="listData">
          <template slot="thead">
            <vs-th class="id-th">
              ID
            </vs-th>
            <vs-th>
              产品名称
            </vs-th>
            <vs-th>
              产品编码
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(tr, index) in data" >
              <vs-td class="id-th">
                <span>{{tr.id}}</span>
              </vs-td>

              <vs-td>
                {{tr.productName}}
              </vs-td>

              <vs-td>
                <div>{{tr.productCode}}</div>
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>
              <vs-td>
                <span
                  class="status"
                  :class="{on: tr.status == 1 }"
                >{{getState(tr)}}</span>
              </vs-td>
              <vs-td>
                <div class="centerx">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="top"
                  >
                    <icon-svg
                       icon-class="edit-21"
                      class="pointer edit-icon"
                      @click.native="editHandle(tr)"
                    ></icon-svg>
                  </el-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="pagination-outer" v-if="total">
          <span class="tatol-count">共计{{total}}条</span>
          <vs-pagination
            class="pagination-box"
            :max="size"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
    <editOrAdd
      :active="active"
      @close="closeHandle"
      :edit-data="editData"
      :is-edit="isEdit"
      @done-success="doneSuccessHandle"
    ></editOrAdd>
  </div>
</template>

<script>
  import editOrAdd from '@/components/product/productList/editOrAdd'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      editOrAdd,
    },
    data() {
      return {
        addDialogShow: false,
        editData: {},
        active: false,
        isEdit: false,
      }
    },
    mixins: [initData],
    created(){
      this.init();
    },
    methods: {
      beforeInit(){
        this.url = 'pms/crm/pageProduct';
        this.params = {
          page: this.page,
          size: this.size,
        }
        if(this.words){
          this.params.basicInfo = this.words;
        }
        return true;
      },
      addHandle() {
        this.isEdit = false;
        this.active = true;
      },
      getState(tr){
        return tr.status == 1 ? '禁用': '启用';
      },
      editHandle(tr){
        this.isEdit = true;
        this.active = true;
        this.editData = tr;
      },
      closeHandle(){
        this.active = false;
      },
      doneSuccessHandle(){
        this.init();
      }
    },
  }
</script>
<style lang="scss">
  .role {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .vs-self-tooltip {
    display: inline-block;
  }
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }

  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .edit-icon {
    font-size: 22px;
  }
</style>
